<template>
  <div>
    <v-snackbar v-model="display" top right color="primary">
      {{ message }}
      <template v-slot:action="{ attrs }">
        <v-btn v-bind="attrs" @click="hide" icon>
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import { get, call } from 'vuex-pathify'

export default {
  name: 'Notify',
  computed: {
    display: get('notify/display'),
    message: get('notify/message')
  },
  methods: {
    show: call('notify/show'),
    hide: call('notify/hide')
  }
}
</script>
